import React from 'react';
import Dots from 'react-native-dots-pagination';
import {AnimatedCircularProgress} from 'react-native-circular-progress';
import {useTheme, useThemedStyles} from '../../../theme';
import makeStyles from './styles';

import {
  Text,
  Image,
  ImageBackground,
  View,
  useWindowDimensions,
} from 'react-native';
import {tID} from '../../../utils/TestIdHelper';

const logoBG = require('../../../assets/images/onBoardingSlideshow/logo_background.webp');
const logo = require('../../../assets/images/logo.webp');

const OnBoardingCard = props => {
  const {colors} = useTheme();
  const styles = useThemedStyles(makeStyles);
  const {
    data: {imageEllipse, image1, image2, image3, headline, subtitle, id},
  } = props; //get data from props

  const {height, width} = useWindowDimensions();

  const progress = Math.ceil(((props.data.id + 1) * 100) / 6); //calculate the progress %

  const newView = () => {
    //render function to be used within Animated circular progress
    return (
      <View style={styles.logoContainer}>
        <Image
          testID={tID(`OnBoardingCard-Image-Logo${id}`)}
          source={logo}
          style={styles.logoImage}></Image>
      </View>
    );
  };

  return (
    <View
      testID={tID(`OnBoardingCard-View-Main${id}`)}
      style={[styles.spaceEven(height, width)]}>
      <Image
        testID={tID(`OnBoardingCard-Image-Cover${id}`)}
        source={imageEllipse}
        resizeMode="cover"
        style={styles.ecllipseImage(props.data.id)}
      />
      <View style={styles.horizontalContainer}>
        <Image
          testID={tID(`OnBoardingCard-Image-FirstSlide${id}`)}
          source={image1}
          style={styles.smallImage(height)}
        />
        <Image
          testID={tID(`OnBoardingCard-Image-SecondSlide${id}`)}
          source={image2}
          style={styles.smallImage(height)}
        />
      </View>
      <View style={styles.verticalContainer}>
        <Image
          testID={tID(`OnBoardingCard-Image-ThirdSlide${id}`)}
          source={image3}
          style={styles.centerImage(height)}></Image>
        <ImageBackground
          testID={tID(`OnBoardingCard-ImageBackground-Logo${id}`)}
          source={logoBG}
          resizeMode="contain">
          <AnimatedCircularProgress
            size={80}
            width={2}
            fill={progress}
            rotation={0}
            children={newView}
            tintColor={colors.accent}
          />
        </ImageBackground>
      </View>
      <View style={styles.marginTop16}>
        <Dots
          length={6}
          active={props.data.id}
          paddingHorizontal={5}
          marginHorizontal={8}
          activeDotWidth={14}
          activeDotHeight={7}
          passiveDotHeight={7}
          passiveDotWidth={7}
          activeColor={colors.accent}
          passiveColor={colors.accentBorder}
        />
      </View>
      <View style={styles.cardText}>
        <Text
          testID={tID(`OnBoardingCard-Text-Heading${id}`)}
          style={styles.headline}>
          {headline}
        </Text>
        <Text
          testID={tID(`OnBoardingCard-Text-SubTitle${id}`)}
          style={styles.subtitle}>
          {subtitle}
        </Text>
      </View>
    </View>
  );
};

export default OnBoardingCard;
